export const APPROVE_ORDER_EVENT = 'approveOrderEvent';
export const UPDATE_REJECTED_SUMMARY = 'UPDATE_REJECTED_SUMMARY';
